export default function sliderPartenaires() {
    if ($('.c-footer__partenaires--slider').length > 0) {

        const $partners = {
            container: $('.c-footer__partenaires--slider')
        }

        if ($partners.container.length > 0) {
            $partners.container.slick({
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 20000,
                draggable: false,
                adaptiveHeight: false,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ],
            });
        }
    }
}
